import { ComponentProps } from 'react';

export const MaoriLanguage = (props: ComponentProps<'span'>) => <span lang="mi" {...props} />;
